import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2, Mail, MapPin } from "lucide-react";
import Mascot from "@/components/Mascot";

const socials = [
  { href: "https://instagram.com/AardvarksVault", label: "Instagram", handle: "@AardvarksVault", Icon: Instagram, testid: "footer-social-instagram" },
  { href: "https://facebook.com/AardvarksVault", label: "Facebook", handle: "Aardvarks Vault", Icon: Facebook, testid: "footer-social-facebook" },
  { href: "https://tiktok.com/@AardvarksVault", label: "TikTok", handle: "@AardvarksVault", Icon: Music2, testid: "footer-social-tiktok" },
];

const Footer = () => (
  <footer className="border-t border-gold/15 bg-navy" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <Mascot size={46} />
          <span className="font-display text-xl font-bold text-cream">
            Aardvarks <span className="text-gold">Vault</span>
          </span>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-cream/70">
          A Texas-based collectibles vault buying Magic: The Gathering, Pokémon, high-value singles, and sealed
          treasures from collectors in all 50 states.
        </p>
      </div>

      <div>
        <p className="eyebrow mb-5">Explore</p>
        <ul className="space-y-3 text-sm">
          {[
            { to: "/", label: "Home", id: "footer-link-home" },
            { to: "/sell", label: "Sell Your Collection", id: "footer-link-sell" },
            { to: "/marketplace", label: "Marketplace", id: "footer-link-marketplace" },
            { to: "/contact", label: "Contact", id: "footer-link-contact" },
            { to: "/privacy", label: "Privacy Policy", id: "footer-link-privacy" },
            { to: "/terms", label: "Terms of Service", id: "footer-link-terms" },
          ].map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={l.id} className="text-cream/70 transition-colors hover:text-gold">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="eyebrow mb-5">Reach the Vault</p>
        <a
          href="mailto:ashton@aardvarksvault.com"
          data-testid="footer-email-link"
          className="flex items-center gap-2 text-sm text-cream/80 transition-colors hover:text-gold"
        >
          <Mail size={16} className="text-gold" /> ashton@aardvarksvault.com
        </a>
        <p className="mt-3 flex items-center gap-2 text-sm text-cream/70">
          <MapPin size={16} className="text-gold" /> Texas-based · Buying nationwide
        </p>
        <div className="mt-6 flex gap-4">
          {socials.map(({ href, label, Icon, testid }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              data-testid={testid}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-gold/25 text-cream/75 transition-all duration-300 hover:-translate-y-0.5 hover:border-gold hover:text-gold"
            >
              <Icon size={17} />
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-cream/10 py-6 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-cream/40">
      © {new Date().getFullYear()} Aardvarks Vault · Texas, USA · Every collection hides a treasure
    </div>
  </footer>
);

export default Footer;
